var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categories),function(category,i){return _c('div',{key:i},[_c('a',{staticClass:"black--text",on:{"click":function($event){return _vm.navigate(category)}}},[_vm._v(" "+_vm._s(category.nombre)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }